const aboutMatchMedia = gsap.matchMedia()

aboutMatchMedia.add("(min-width: 640px)", (context) => {
    context.add("animateAbout", () => {
        // const chips = gsap.utils.toArray(".about-chips");
        gsap.timeline({
            scrollTrigger: {
                trigger: ".about",
                start: "top center",
                end: "bottom top",
                toggleActions: "play none none reverse",
            }
        })
        .fromTo(".about-chip", {
            top: "50%",
            left: "50%",
        }, {
            duration: 1,
            stagger: 0.1,
            top(_i, target) {
                return `${target.dataset.top}%`
            },
            left(_i, target) {
                return `${target.dataset.left}%`
            },
        })
        .fromTo(".about-chip", {
            opacity: 0,
        }, {
            duration: 1,
            stagger: 0.1,
            opacity: 1,
        }, "<25%")
    });

    context.animateAbout();
    document.addEventListener("shopify:section:load", context.animateAbout);

    return () => {
        document.removeEventListener("shopify:section:load", context.animateAbout)
    }
});